module.exports = __webpack_public_path__ + "static/media/android.29e8d801.md";